import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

const styles = {
  axisLabel: {
    position: 'absolute',
    top: 5,
  },
  innerAxisLabel: {
    position: 'relative',
  },
  axisLabelType2: {},
  axisLabelType3: {},
  innerAxisLabelType2: {
    color: '#4eab96',
    fontWeight: 'bold',
    backgroundColor: 'white',
    top: '20px',
    paddingLeft: 5,
    paddingRight: 5,
  },
  innerAxisLabelType3: {
    color: 'black',
    fontWeight: 'bold',
    bottom: '45px',
    backgroundColor: 'white',
    paddingLeft: 5,
    paddingRight: 5,
  },
}

const AxisLabel = ({
  classes,
  label,
  percent,
  type2,
  type3,
  className,
  innerClassName,
}) => {
  return (
    <div
      className={classNames({
        [classes.axisLabel]: true,
        [classes.axisLabelType2]: type2,
        [classes.axisLabelType3]: type3,
        [className]: true,
      })}
      style={{ left: percent + '%' }}
    >
      <span
        className={classNames({
          [classes.innerAxisLabel]: true,
          [classes.innerAxisLabelType2]: type2,
          [classes.innerAxisLabelType3]: type3,
          [innerClassName]: true,
        })}
        // This is just a rough guess at the label length to try and
        // center it
        style={{
          left: (-(label + '').length * 8) / 2 + (type2 || type3 ? -5 : 0),
        }}
      >
        {label}
      </span>
    </div>
  )
}

export default injectStyles(styles)(AxisLabel)



// WEBPACK FOOTER //
// ./src/Components/Stats/BulletChartRaw/AxisLabel.js